import * as R from "ramda"

export const calendly = "https://calendly.com/dalma-kennenlernen/15-min"

export const termsAndConditions = {
  name: "Terms & conditions",
  description: "IPID PDF - 211 Ko",
  link: "https://editique.de.dalma.tech/public/dalma-de/latest/Terms_and_conditions_Dalma_de.pdf",
}

export const IPID = {
  name: "IPID",
  description: "IPID PDF - 178 Ko",
  link: "https://editique.de.dalma.tech/public/dalma-de/latest/IPID_Dalma_de.pdf",
} as const

export const privacyAndCookiesPolicies = {
  name: "Policies Dalma",
  description: "IPID PDF - 178 Ko",
  link: "https://editique.de.dalma.tech/public/dalma-de/latest/Policies_Dalma_de.pdf",
}

export const garanteesTable = {
  name: "Garantees Table Dalma",
  description: "Garantees PDF - 4.8 Ko",
  link: "https://editique.de.dalma.tech/public/dalma-de/latest/Tabelle_der_garantien_Dalma_de.pdf",
}

export const informationNotice = {
  name: "Information Notice Dalma",
  description: "Garantees PDF - 3.5 Mo",
  link: "https://editique.de.dalma.tech/public/dalma-de/latest/NI_Dalma_de.pdf",
}

export const Erstinformationen = {
  name: "Erstinformationen Dalma",
  description: "Erstinformationen PDF - 14.9Mo",
  link: "https://editique.de.dalma.tech/public/dalma-de/latest/CLDALMADE/Erstinformation_Dalma_de.pdf",
}

const LEGAL_LINKS = {
  CGU: "https://editique.de.dalma.tech/public/dalma-de/latest/RC_CONTRACT_ID/Terms_and_conditions_Dalma_de.pdf",
  FIC: "https://editique.de.dalma.tech/public/dalma-de/latest/RC_CONTRACT_ID/FIC_Dalma_de.pdf",
  PRIVACY_POLICY_URL:
    "https://editique.de.dalma.tech/public/dalma-de/latest/RC_CONTRACT_ID/Policies_Dalma_de.pdf",
  IPID: "https://editique.de.dalma.tech/public/dalma-de/latest/RC_CONTRACT_ID/IPID_Dalma_de.pdf",
  NI: "https://editique.de.dalma.tech/public/dalma-de/latest/RC_CONTRACT_ID/NI_Dalma_de.pdf",
  Erstinformation: "https://editique.de.dalma.tech/public/dalma-de/latest/RC_CONTRACT_ID/Erstinformation_Dalma_de.pdf",
} as const

export function buildLegalURL(
  rcContractId: string | undefined | null,
  documentType: keyof typeof LEGAL_LINKS
) {
  if (rcContractId) {
    return R.replace("RC_CONTRACT_ID", rcContractId, LEGAL_LINKS[documentType])
  }
  return R.replace("/RC_CONTRACT_ID", "", LEGAL_LINKS[documentType])
}

export const DE_APP_DOWNLOAD_URL = "https://dalma-de.onelink.me/cLht/9uutwvne"